import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withResizeDetector } from 'react-resize-detector';

import { fetchAssessment, fetchCountryInfo, receiveAppType } from '../../../actions/appActions';
import { getVersionId, propExistsAndNonEmpty } from '../../../util/utils';

import PromptContainer from '../../prompt/promptContainer';
import ProgressBarContainer from '../../progressBar/progressBarContainer';
import ResultsContainer from '../../results/resultsContainer';
import SinglePageContainer from '../../singlePage/singlePageContainer';
import Loading from '../../loading/loading';
import Modal from '../../modal/modal';
import Header from '../../header/header';
import SponsorHeader from '../../sponsorHeader/sponsorHeader';
import EngagementTimer from '../../engagementTimer/engagementTimer';
import InlineWhisper from '../../inlineWhisper/inlinewhisper';
import Intro from '../../intro/intro';

import ProtectedRoute from '../protected/protected';

import './assessmentApp.scss';

const mapStateToProps = state => {
    return {
        inlineInfo: state.inline.info,
        inlineConfig: state.inline.config,
        countryInfo: state.app.countryInfo,
        assessment: state.app.assessment,
        promptQueue: state.session.promptQueue
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchCountryInfo: () => dispatch(fetchCountryInfo()),
        fetchAssessment: (assessmentName, versionId) =>
            dispatch(fetchAssessment(assessmentName, versionId)),
        receiveAppType: type => dispatch(receiveAppType(type))
    };
};

class AssessmentApp extends React.Component {
    constructor(props) {
        super(props);

        this.assessmentName = this.props.match.params.assessmentName;
        this.appType = 'Assessment';

        this.setInlineClassName = this.setInlineClassName.bind(this);
    }

    componentDidMount() {
        this.props.fetchCountryInfo();

        const versionId = getVersionId(this.props.location.search);
        this.props
            .fetchAssessment(this.assessmentName, versionId)
            .then(() => this.setAppTitle(this.props.assessment.tabTitle));

        this.props.receiveAppType(this.appType);
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.height !== nextProps.height) {
            return true;
        }

        if (this.props.inlineInfo.status !== nextProps.inlineInfo.status) {
            return true;
        }

        // Unless there is an update to assessment info, do not rerender this parent application
        if (this.props.assessment === nextProps.assessment) {
            return false;
        }

        return true;
    }

    componentDidUpdate() {
        if (window.hlPostHeight && this.props.inlineInfo.status) {
            window.hlPostHeight(this.props.height);
        }
    }

    handleGeoValidation() {
        if (propExistsAndNonEmpty(this.props.assessment)) {
            const { countryInfo, assessment } = this.props;
            const restriction = assessment.countryRestriction;

            if (restriction.type === 'none') {
                return;
            }

            if (restriction.type === 'include') {
                if (restriction.countryCodes.indexOf(countryInfo) < 0) {
                    this.redirectToSite();
                }
            } else if (restriction.countryCodes.indexOf(countryInfo) > 0) {
                this.redirectToSite();
            }
        }
    }

    // eslint-disable-next-line class-methods-use-this
    setAppTitle(title) {
        document.title = title || 'Find Your Results';
    }

    setInlineClassName() {
        if (this.props.inlineInfo.status) return ' inline';
        return '';
    }

    // eslint-disable-next-line class-methods-use-this
    redirectToSite() {
        window.location = 'https://www.healthline.com';
    }

    render() {
        this.handleGeoValidation();

        const { inlineInfo, inlineConfig, assessment } = this.props;

        return (
            <div className={`main-app${this.setInlineClassName()}`}>
                <div className="assessment">
                    <Switch>
                        <Route
                            exact
                            path={`/assessment/${this.assessmentName}/intro`}
                            component={Intro}
                        />

                        <Route path={`/assessment/${this.assessmentName}`}>
                            <EngagementTimer />

                            <div className="sticky">
                                {inlineInfo.status && inlineConfig.hideHeader ? null : <Header site={assessment.site}/>
                                }
                                
                                <Route
                                    exact
                                    path={`/assessment/${this.assessmentName}/results`}
                                >
                                    {assessment.sponsorImageUrl && <SponsorHeader sponsorImageUrl={assessment.sponsorImageUrl} sponsorUrl={assessment.sponsorUrl} />}
                                </Route>
                                {inlineInfo.status ? null : (
                                    <Route
                                        path={`/assessment/${this.assessmentName}/prompt`}
                                        component={ProgressBarContainer}
                                    />
                                )}
                            </div>

                            <InlineWhisper
                                isInline={inlineInfo.status}
                                whisper={inlineConfig.whisper}
                                sponsorImageUrl={assessment?.sponsorImageUrl}
                                sponsorUrl={assessment?.sponsorUrl}
                                site={assessment.site}
                            />

                            <Route path={`/assessment/${this.assessmentName}`} component={Modal} />
                            <Switch>
                                <ProtectedRoute
                                    exact
                                    path={`/assessment/${this.assessmentName}/prompt/:promptId`}
                                    component={PromptContainer}
                                />
                                <Route
                                    exact
                                    path={`/assessment/${this.assessmentName}/loading`}
                                    component={Loading}
                                />
                                <Route
                                    exact
                                    path={`/assessment/${this.assessmentName}/results`}
                                    component={ResultsContainer}
                                />
                                <Route
                                    exact
                                    path={`/assessment/${this.assessmentName}/single`}
                                    component={SinglePageContainer}
                                />
                            </Switch>
                        </Route>
                    </Switch>
                </div>
            </div>
        );
    }
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withResizeDetector(AssessmentApp))
);
